import React from 'react';
import s from "./MySkeleton.module.scss"

const MySkeleton = ({width}) => {
  return (
    <div className={`${s.mySkeleton} ${s.wave}`} style={{width}}></div>
  );
};

export default MySkeleton;